import React from 'react'

export default function SettingsPage() {
  return (
    <div>
      SettingsPage here!
    </div>
  )
}
